export default __webpack_public_path__ + "img/675c0a0bfeaeda5c285880d65a0904eb.svg";